<template>
  <section>
    <div class="row mt-3">
      <div class="col-12">
        <b-list-group>
          <b-list-group>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
            :href="file.url"
            v-for="(file, index) in files"
          >
            {{ index + 1 }}. {{ file.label }}
            <b-icon icon="file-earmark-text" font-scale="2"></b-icon>
          </b-list-group-item>
        </b-list-group>
        </b-list-group>
      </div>
    </div>
  </section>
</template>
<script>
import Vue from 'vue'

import { IconsPlugin } from 'bootstrap-vue'
import { ListGroupPlugin } from 'bootstrap-vue'

Vue.use(IconsPlugin)
Vue.use(ListGroupPlugin)

export default {
  name: "vegetarian",
  data() {
    return {
      files: [
        {
          label: '素食的利益 （廣化法師）',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/vegetarian/benefits-of-vegetarianism.pdf'
        },
        {
          label: '肉食之害 （楊梓茗居士譯）',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/vegetarian/the-harm-of-eating-meat.pdf'
        },
        {
          label: '防癌手冊 （圓因法師）',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/vegetarian/cancer-prevention-manual.pdf'
        },
        {
          label: '藏密素食觀 （索達吉堪布）',
          url: 'https://www2.budaedu.org/official-website-data/love-life/article/vegetarian/tibetan-buddhist-view-on-vegetarianism.pdf'
        }
      ]
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  }
}
</script>